/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useFlags } from 'sarsaparilla';

import { FlexDatePicker, type FlexDateFilters } from 'shared-ui/flex-date-picker';

import { FlexDates } from '../../components/homepage/FlexDates/FlexDates';
import type { FiltersProps } from '../../components/homepage/FlexDates/FlexDates.types';
import {
    legacyFiltersEqual,
    toFlexDateFilters,
    toLegacyFilters,
} from '../../components/homepage/FlexDates/FlexDates.utils';

interface HeroDatesProps {
    onLegacyFiltersChange: (filters: FiltersProps) => void;
    legacyFlexFilters: FiltersProps;
}

/**
 * Renders the homepage camping tab's date control, switching between the
 * legacy FlexDates and the new FlexDatePicker on the `newSearchDatePicker` flag.
 * Both read and write the hero's legacy filter object.
 */
export function HeroDates({ onLegacyFiltersChange, legacyFlexFilters }: HeroDatesProps) {
    const { newSearchDatePicker } = useFlags();

    const handleFlexDateChange = (value: FlexDateFilters) => {
        const nextFilters = toLegacyFilters(value);
        if (legacyFiltersEqual(nextFilters, legacyFlexFilters)) {
            return;
        }

        onLegacyFiltersChange(nextFilters);
    };

    if (newSearchDatePicker) {
        return (
            <FlexDatePicker
                value={toFlexDateFilters(legacyFlexFilters)}
                onChange={handleFlexDateChange}
                isFlexibleAllowed
                clickTagCategory="Homepage"
                size="lg"
                popoverAlign="end"
            />
        );
    }

    return (
        <FlexDates
            monthsLimit={4}
            onFiltersChange={onLegacyFiltersChange}
            filters={legacyFlexFilters}
            isSearch={false}
            showClear
        />
    );
}
